import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Typography, Button } from "@mui/material";
import { LoginIcon } from "src/components/icons/PersonIcons";

export default function LoginButton(props) {
  const navigate = useNavigate();
  const handleKlik = () => navigate("/login");

  return (
    <Button onClick={handleKlik} style={{ display: "flex", gap: 4 }}>
      <LoginIcon color="primaryDark" />
      {!props.noText && <Typography color="primaryDark">Kirjaudu</Typography>}
    </Button>
  );
}

LoginButton.propTypes = {
  noText: PropTypes.bool,
};
